function applyIubendaClasses() {
  const iubendaId = window.siteConfig?.iubenda;

  const privacyElements = document.querySelectorAll(
    '.fui-field[data-field-handle="privacyPolicy"]',
  );

  privacyElements.forEach((el) => {
    const link = el.querySelector("a");
    if (link) {
      // Update href with iubenda ID if available
      if (iubendaId && link.href.includes("iubenda.com")) {
        link.href = link.href.replace(
          /iubenda\.com\/[^/]+/,
          `iubenda.com/privacy-policy/${iubendaId}`,
        );
      }

      link.classList.add(
        "iubenda-white",
        "iubenda-noiframe",
        "iubenda-embed",
        "iubenda-nostyle",
        "text-prim",
      );

      // Wait for Iubenda's embed to apply its own inline style
      setTimeout(() => {
        link.style.width = "auto";
      }, 500);
    }
  });
}

document.addEventListener("DOMContentLoaded", applyIubendaClasses);
document.addEventListener("formieRender", applyIubendaClasses);

/// Add lenis prevent on iubenda Iframe ////
// Wait for iubenda button to exist before attaching click listener
const waitForIubendaButton = setInterval(() => {
  const iubendaBtn = document.querySelector(
    ".iubenda-tp-btn.iubenda-cs-preferences-link"
  );
  if (iubendaBtn) {
    clearInterval(waitForIubendaButton);
    iubendaBtn.addEventListener("click", () => {
      const observer = new MutationObserver((mutations, obs) => {
        const iframeDiv = document.getElementById("iubenda-iframe");
        if (iframeDiv) {
          iframeDiv.setAttribute("data-lenis-prevent", "");
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}, 500);
